import { getShowBalanceButton } from 'redesign/components/templates/absence-request-details/utils/office/get-show-balance-button'
import type { GetNewAbsenceActionButtonsProps } from '../types'

export const getNewAbsenceActionButtons = ({
  t,
  onSubmit,
  setIsBalanceDrawerOpen,
  balanceDisabled,
}: GetNewAbsenceActionButtonsProps) => [
  {
    label: t('absenceRequest.new.sendRequest'),
    testId: 'absence-request_new_request',
    onClick: onSubmit,
  },
  getShowBalanceButton({ t, openBalanceDrawer: () => setIsBalanceDrawerOpen(true), balanceDisabled }),
]
